// 플랜 등급 매핑 — 상위 플랜은 하위 포함 (1=Basic, 2=Pro, 3=Pro Plus)
export const SERVICE_CODE_RANK = {
  qesg_basic: 1,
  qesg_pro: 2,
  qesg_pro_plus: 3,
  qesg_ai_only: 3,
  enterprise: 3
};

export const service_list = [
  {
    service_code: 'qesg_basic',
    service_name: 'Basic',
    product_show_price_text: '2,400,000원 / 12개월',
    product_price_text: '2,160,000원 / 12개월',
    product_price: 2160000,
    describe: '편집권한 : 1개 보고서 편집 가능',
    describe_sub: '초대 및 동시작성 3인까지'
  },
  {
    service_code: 'qesg_pro',
    service_name: 'Pro',
    product_show_price_text: '4,500,000원 / 12개월',
    product_price_text: '4,050,000원 / 12개월',
    product_price: 4050000,
    describe: '웹 보고서 이용 가능',
    describe_sub: '초대 및 동시작성 6인까지'
  },
  {
    service_code: 'qesg_pro_plus',
    service_name: 'Pro +',
    product_show_price_text: '5,400,000원 / 12개월',
    product_price_text: '4,860,000원 / 12개월',
    product_price: 4860000,
    describe: 'A.I. 작성 도우미 이용 가능',
    describe_sub: '초대 및 동시작성 무제한'
  },
  {
    service_code: 'enterprise',
    service_name: 'Enterprise',
    product_show_price_text: '별도 문의',
    product_price_text: '',
    product_price: 0,
    describe: '편집권한 : 다수의 보고서 편집 가능',
    describe_sub: '커스텀 Feature/API 이용가능'
  }
];
